import React from "react"
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

import Navbar from "./components/Navbar"
import Home from "./components/pages/HomePage/Home"
import Test from "./components/pages/Test/Test"
import Aerodromes from "./components/pages/Aerodromes/Aerodromes"
import MetarTAF from "./components/pages/MetarTAF/MetarTAF"
import MSD from "./components/pages/MSD/MSD"
import Footer from "./components/Footer"

import PageNotFound from "./PageNotFound"

import "bootstrap/dist/css/bootstrap.min.css"
import "./App.css";

const App = () => {

  return (
    <div className="App">

      <Router>
        <Navbar />
        <Routes>
          <Route path='/' exact element={<Home />} />
          <Route path='/test' element={<Test />} />

          <Route path='/aerodromes' element={<Aerodromes />} />
          <Route path='/metar-taf' element={<MetarTAF />} />
          <Route path='/msd' element={<MSD />} />
          <Route component={<PageNotFound />} />
        </Routes>
      </Router>
      <Footer />
    </div>
  );
}

export default App;